<template>
  <el-drawer
    :title="titleDrawer"
    :visible.sync="drawerVacacionesOrigen"
    :before-close="closeDrawerVacaciones"
    @closed="closeDrawerVacaciones"
    size="35%"
  >
    <el-container direction="vertical" id="vacation-pdf-content">
      <el-main>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form
              ref="form"
              label-position="left"
              size="mini"
              label-width="200px"
              :model="model"
            >
              <el-form-item label="Fecha Solicitud" v-if="isView == true">
                <el-date-picker
                  type="datetime"
                  placeholder="Fecha Solicitud"
                  v-model="model.ApplicationDate"
                  :disabled="isView"
                >
                </el-date-picker>
              </el-form-item>

              <!-- select employeeId -->
              <el-form-item
                label="Empleado"
                prop="IdEmployee"
                :rules="[
                  {
                    required: true,
                    message: 'Seleccione un empleado',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-select
                  v-loading="autoLoading"
                  v-model="model.IdEmployee"
                  filterable
                  clearable
                  size="mini"
                  placeholder="Colaborador"
                  @change="updateSelectedEmployee"
                >
                  <el-option
                    v-for="item in employeesByDirection"
                    :key="item.EmployeeID"
                    :label="item.Name"
                    :value="item.EmployeeID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Cedula" v-if="isView == true">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="model.Cedula"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="Departamento" v-if="isView == true">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="model.Department"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="Posicion" v-if="isView == true">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="model.Position"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item
                label="Desde"
                prop="StartDate"
                :rules="[
                  {
                    required: true,
                    message: 'Inserta una fecha válida',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-date-picker
                  type="datetime"
                  format="dd-MM-yyyy HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="Fecha Inicio"
                  v-model="model.StartDate"
                  :disabled="isView"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                label="Hasta"
                prop="FinishDate"
                :rules="[
                  {
                    required: true,
                    message: 'Inserta una fecha válida',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-date-picker
                  type="datetime"
                  format="dd-MM-yyyy HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="Fecha Fin"
                  v-model="model.FinishDate"
                  :disabled="isView"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="No. Dias entre fechas">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="model.NoDays"
                  disabled
                >
                </el-input>
              </el-form-item>

              <div
                v-if="model.StartDate && model.FinishDate"
                style="display: flex; gap: 15px"
              >
                <el-form-item label="Sábados:">
                  {{ countSaturdays }}</el-form-item
                >
                <el-form-item label="Domingos:" style="margin-left: 15px">
                  {{ countSundays }}</el-form-item
                >
              </div>

              <el-alert
                v-if="model.StartDate && model.FinishDate"
                title="Tomar en cuenta que los sábados son medio día."
                description="2 sábados = 1 día.
                4 sábados = 2 días."
                type="info"
                effect="dark"
                style="margin-bottom: 10px"
              >
              </el-alert>

              <el-form-item label="No. Dias Vacaciones">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="noDaysWithoutWeeknd"
                  disabled
                >
                </el-input>
              </el-form-item>

              <el-form-item
                label="Periodo"
                prop="Period"
                :rules="[
                  {
                    required: true,
                    message: 'Inserta un Período',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-select
                  v-model="model.Period"
                  placeholder="Año"
                  size="mini"
                  @change="handleChangeYear"
                >
                  <el-option
                    v-for="item in years"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Observaciones">
                <el-input
                  type="textarea"
                  autosize
                  placeholder="Please input"
                  v-model="model.Observations"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item
                label="Motivo rechazo supervisor"
                v-if="model.SupervisorRejectionComment"
              >
                <el-input
                  type="textarea"
                  autosize
                  placeholder="Motivo"
                  v-model="model.SupervisorRejectionComment"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item
                label="Motivo rechazo RRHH"
                v-if="model.RRHH_RejectionComment"
              >
                <el-input
                  type="textarea"
                  autosize
                  placeholder="Motivo"
                  v-model="model.RRHH_RejectionComment"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  v-if="isCreated"
                  type="primary"
                  :loading="autoLoading"
                  @click="CreateRequestVacation()"
                  :disabled="autoLoading"
                  >Crear Solicitud</el-button
                >
                <el-row>
                  <el-button
                    v-if="isView && model.excution_evidence"
                    type="primary"
                    size="mini"
                    :loading="autoLoading"
                    @click="viewEvidence()"
                    :disabled="autoLoading"
                    >Ver Evidencia</el-button
                  >
                </el-row>

                <el-button
                  v-if="isView"
                  type="primary"
                  :loading="autoLoading"
                  @click="exportToExcel()"
                  :disabled="autoLoading"
                  >Exportar Excel</el-button
                >
                <el-button
                  v-if="isView"
                  type="primary"
                  :loading="autoLoading"
                  @click="printToPDF()"
                  :disabled="autoLoading"
                  >Imprimir PDF</el-button
                >
                <el-button
                  v-if="isEdit"
                  type="primary"
                  :loading="autoLoading"
                  @click="EditRequestVacation()"
                  :disabled="autoLoading"
                  >Editar Solicitud</el-button
                >
                <el-button
                  @click="closeDrawerVacaciones()"
                  :disabled="autoLoading"
                  >Cancel</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>
<script>
// import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
//import { log } from "console";
import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx";

export default {
  name: "DrawerVacaciones",
  components: {
    // EmployeeSelector
  },
  props: {
    drawerVacacionesOrigen: {
      type: Boolean,
      default: false
    },

    dataVacaciones: {
      type: Array,
      default: () => []
    } /*,
    CurrentEmployID: {
      type: Number,
      default: this.currentUser.EmployeeId
    }*/
  },

  data() {
    //let self =  this
    //console.log("this: ", this, "\n self: ", self)
    //let currentEmployID = this.currentUser.EmployeeId
    return {
      autoLoading: false,
      data: [],
      titleDrawer: "Solicitud de Vacaciones",

      //DATA NECESARIA PARA EL FORMULARIO
      conteoDiasSolicitados: 0,
      noDaysWithoutWeeknd: 0,
      model: {
        ApplicationDate: "",
        IdEmployee: 0, // this.CurrentEmployID,
        Cedula: "",
        Department: "",
        Position: "",
        NoDays: 0,
        StartDate: "",
        FinishDate: "",
        Period: new Date().getFullYear(),
        Observations: "",
        SupervisorApproval: 0,
        RRHH_Approval: 0,
        SupervisorRejectionComment: null,
        RRHH_RejectionComment: null
      },

      //drawer: false
      isCreated: true,
      isView: false,
      isEdit: false,
      IdUserSelect: 0,

      //the weekend
      countSundays: 0,
      countSaturdays: 0,

      employeesByDirection: [],

      status: {
        Pendiente: { Value: 0 },
        Rechazado: { Value: 1 },
        Aprobado: { Value: 2 },
        Ejecutado: { Value: 3 }
      }
    };
  },
  mounted() {
    //console.log("Current user id: ", this.currentUser.EmployeeId)
    this.model.IdEmployee = this.currentUser.EmployeeId;
    this.model.Period = new Date().getFullYear();
    this.GetEmployees();
  },
  computed: {
    calculateNoDays() {
      if (this.model.StartDate && this.model.FinishDate) {
        const startDate = new Date(this.model.StartDate);
        const finishDate = new Date(this.model.FinishDate);

        // Verificar si la fecha inicial y la fecha final son del mismo día
        const isSameDay =
          startDate.toDateString() === finishDate.toDateString();

        // Verificar si la diferencia de hora es igual o mayor a 9 horas
        const is8Hours = finishDate.getHours() - startDate.getHours();

        let differenceInDays = 0;

        if (isSameDay) {
          if (is8Hours >= 9) {
            differenceInDays = 1; // Contar como 1 día completo
          } else if (is8Hours < 9) {
            differenceInDays = 0; // No contar como día completo
          }
        } else {
          // Calcular la diferencia en días como se hacía anteriormente
          const differenceInTime =
            finishDate.getTime() - startDate.getTime() + 1;
          differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
        }

        let differenceInDaysValidated =
          differenceInDays < 0 ? 0 : differenceInDays;

        // Verificar si la fecha final es mediodía (12:00 PM)
        const isFinishDateMidday =
          finishDate.getHours() === 12 && finishDate.getMinutes() === 0;

        // Si la fecha final es mediodía y no se consideró como día completo, contar como 0.5 días
        if (isFinishDateMidday && differenceInDaysValidated !== 1) {
          differenceInDaysValidated -= 0.5;
        }

        return differenceInDaysValidated;
      } else {
        return "";
      }
    },
    years() {
      const lowLevel = new Date().getFullYear() - 2;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 2; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    },
    calcularSabadosDomingos() {
      // Obtener la fecha de inicio y fin
      if (this.model.StartDate && this.model.FinishDate) {
        const start = new Date(this.model.StartDate);
        const end = new Date(this.model.FinishDate);

        let saturdays = 0;
        let saturdays05 = 0;
        let sundays = 0;

        // Iterar sobre cada día entre las fechas
        const currentDate = new Date(start);
        while (currentDate <= end) {
          const dayOfWeek = currentDate.getDay(); // 0 (domingo) - 6 (sábado)

          if (dayOfWeek === 6) {
            // Es sábado
            saturdays++;
            saturdays05 = saturdays05 + 0.5;
          } else if (dayOfWeek === 0) {
            // Es domingo
            sundays++;
          }

          // Avanzar al siguiente día
          currentDate.setDate(currentDate.getDate() + 1);
        }

        let theWeeknd = {
          Saturday: saturdays,
          Saturday05: saturdays05,
          Sunday: sundays
        };

        return theWeeknd;
      } else {
        return "";
      }
    }
  },
  watch: {
    calculateNoDays(newVal) {
      this.model.NoDays = newVal;
    },
    calcularSabadosDomingos(newVal) {
      // console.log("MELVIN", newVal);
      let sum = newVal.Saturday05 + newVal.Sunday;
      this.countSaturdays = newVal.Saturday;
      this.countSundays = newVal.Sunday;
      this.noDaysWithoutWeeknd = Math.abs(sum - this.model.NoDays);
    },
    dataVacaciones() {
      this.GetRequestedDaysVacation();
    }
  },
  methods: {
    isRRHHOrCEO() {
      //CEO = 16 // GERENTE RRHH = 68
      if (
        this.currentUser.PositionID == 16 ||
        this.currentUser.PositionID == 68 ||
        this.currentUser.EmployeeId == 196 ||
        this.currentUser.EmployeeId == 220
      ) {
        return true;
      }
      return false;
    },
    CreateRequestVacation() {
      let today = new Date();
      //let todayValidate = today.getDate();
      // this.$emit("olas");
      //console.log("dias solicitados: ", this.conteoDiasSolicitados)
      if (this.conteoDiasSolicitados + this.noDaysWithoutWeeknd > 14) {
        this.$message({
          message: "EL conteo de dias solicitados no puede ser mas de 14.",
          type: "warning"
        });
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.autoLoading = true;
            this.$http
              .get("/api/Modules/AddRequestVacations", {
                params: {
                  IdEmployee:
                    this.model.IdEmployee != null
                      ? this.model.IdEmployee
                      : this.currentUser.EmployeeId,
                  ApplicationDate: today,
                  Cedula: this.model.Cedula,
                  //Department: this.Department,
                  Position: this.model.Position,
                  // NoDays: this.model.NoDays,
                  NoDays: this.noDaysWithoutWeeknd,
                  StartDate: this.model.StartDate,
                  FinishDate: this.model.FinishDate,
                  Period: this.model.Period,
                  Observations: this.model.Observations,
                  SupervisorApproval: this.model.SupervisorApproval,
                  RRHH_Approval: this.model.RRHH_Approval,
                  CreateBy: this.currentUser.EmployeeId
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                this.data = resp.data;
              })
              .catch((error) => {
                this.$message.error("Error al cargar detalles", error);
              })
              .finally(() => {
                this.autoLoading = false;
                this.closeDrawerVacaciones();
              });
          }
        });
      }
    },
    EditRequestVacation() {
      let today = new Date();
      if (this.conteoDiasSolicitados + this.noDaysWithoutWeeknd > 14) {
        this.$message({
          message: "EL conteo de dias solicitados no puede ser mas de 14.",
          type: "warning"
        });
      } else {
        // TODO:
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.autoLoading = true;
            this.$http
              .get("/api/Modules/EditVacationsRequest", {
                params: {
                  IdEmployee:
                    this.model.IdEmployee != null
                      ? this.model.IdEmployee
                      : this.currentUser.EmployeeId,
                  ApplicationDate: today,
                  Cedula: this.model.Cedula,
                  //Department: this.Department,
                  Position: this.model.Position,
                  // NoDays: this.model.NoDays,
                  IdRequest: this.model.IdRequest,
                  NoDays: this.noDaysWithoutWeeknd,
                  StartDate: this.model.StartDate,
                  FinishDate: this.model.FinishDate,
                  Period: this.model.Period,
                  Observations: this.model.Observations,
                  SupervisorApproval: 0,
                  RRHH_Approval: 0
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                this.data = resp.data;
              })
              .catch((error) => {
                this.$message.error("Error al cargar detalles", error);
              })
              .finally(() => {
                this.autoLoading = false;
                this.closeDrawerVacaciones();
              });
          }
        });
      }
    },

    GetRequestedDaysVacation() {
      this.$http
        .get("/api/Modules/GetRequestedDaysVacation", {
          params: {
            EmployeeID: this.model.IdEmployee,
            Period: this.model.Period
          },
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          this.conteoDiasSolicitados = resp.data;
        })
        .catch((error) => {
          this.$message.error("Error al cargar detalles", error);
        })
        .finally(() => {
          this.autoLoading = false;
          // this.closeDrawerVacaciones();
        });
    },

    async printToPDF() {
      this.autoLoading = true;
      let nameEmployee;
      this.employeesByDirection.forEach(async (d) => {
        if (d.EmployeeID == this.model.IdEmployee) {
          nameEmployee = d.Name;
        }
      });
      const element = await document.getElementById("vacation-pdf-content"); // ID del elemento que deseas imprimir
      await html2pdf()
        .from(element)
        .save(nameEmployee + "-Vacaciones.pdf");
      this.autoLoading = false;
    },

    async exportToExcel() {
      this.autoLoading = true;
      let nameEmployee;
      this.employeesByDirection.forEach(async (d) => {
        if (d.EmployeeID == this.model.IdEmployee) {
          nameEmployee = d.Name;
        }
      });
      const data = [
        {
          "Fecha de Creación": this.model.ApplicationDate,
          Empleado: nameEmployee,
          Cédula: this.model.Cedula,
          Departamento: this.model.Department,
          Posición: this.model.Position,
          "No. Días": this.noDaysWithoutWeeknd,
          "Fecha Inicio": this.model.StartDate,
          "Fecha Final": this.model.FinishDate,
          Período: this.model.Period,
          Observaciones: this.model.Observations,
          "Aprovado Por Supervisor": this.model.SupervisorApproval,
          "Aprovado Por RRHH": this.model.RRHH_Approval
        }
      ];

      // Crear una nueva hoja de cálculo
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Aplicar estilos y formatos personalizados
      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
        fill: { fgColor: { rgb: "FF000000" } },
        border: { bottom: { style: "thin", color: { rgb: "00000000" } } }
      };

      const cellStyle = {
        alignment: { horizontal: "center" },
        border: { bottom: { style: "thin", color: { rgb: "00000000" } } }
      };

      // Aplicar estilos al encabezado
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: col });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = headerStyle;
      }

      // Aplicar estilos a las celdas de datos
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          if (!worksheet[cellAddress]) continue;
          worksheet[cellAddress].s = cellStyle;
        }
      }

      // Ajustar el ancho de las columnas
      const columnWidths = [
        { wch: 10 }, // Ancho de la primera columna
        { wch: 15 } // Ancho de la segunda columna
        // ... y así sucesivamente
      ];
      worksheet["!cols"] = columnWidths;

      // Agregar la hoja de cálculo al libro de trabajo
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Generar el archivo de Excel
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      // Descargar el archivo
      const dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = nameEmployee + "-Permiso.xlsx";
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(dataBlob);
      downloadLink.download = fileName;
      downloadLink.click();
      this.autoLoading = false;
    },

    closeDrawerVacaciones() {
      this.$emit("dialog-closed");
      this.clear();
      this.drawerVacacionesOrigen = false;
    },
    handleChangeYear(year) {
      this.model.Period = year;
      this.GetRequestedDaysVacation();
    },

    updateSelectedEmployee() {
      this.GetRequestedDaysVacation();
    },

    getUpdatedData() {
      this.$emit("update-data");
    },

    show(data = {}, isView = false, isCreated = false, isEdit = false) {
      if (isCreated) {
        this.isView = false;
        this.titleDrawer = "Solicitud de Vacaciones";
        this.data = data;
      }
      if (isView) {
        (this.titleDrawer = "Informacion Sobre Solicitud"),
          (this.isCreated = false),
          (this.model = {
            ...this.model,
            ...data.task
          });
        this.isView = isView;
        this.isEdit = isEdit;
        this.data = data.task.row;
      }
      if (isEdit) {
        (this.titleDrawer = "Editar Informacion Sobre Solicitud"),
          (this.isCreated = false),
          (this.model = {
            ...this.model,
            ...data.task
          });
        this.isView = isView;
        this.isEdit = isEdit;
        this.data = data.task.row;
        // Normalizar fechas
        if (this.model.StartDate) {
          this.model.StartDate = new Date(this.model.StartDate)
            .toISOString()
            .replace("T", " ")
            .slice(0, 19);
        }
        if (this.model.FinishDate) {
          this.model.FinishDate = new Date(this.model.FinishDate)
            .toISOString()
            .replace("T", " ")
            .slice(0, 19);
        }
      }
      this.drawerVacacionesOrigen = true;
    },

    DeleleVacationRequest(rowData) {
      this.$confirm(
        "Estas seguro que deseas eliminar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.$http
            .delete(
              `/api/Modules/DeleteVacationsRequest?IdRequest=${rowData.task.IdRequest}`,
              {
                timeout: 3 * 60 * 100
              }
            )
            .then(() => {
              this.$message({
                type: "success",
                message: "Eliminado correctamente"
              });
            })
            .catch((error) => {
              this.$message.error("Error al eliminar la solicitud", error);
            })
            .finally(() => {
              this.autoLoading = false;
              this.closeDrawerVacaciones();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Eliminación cancelada"
          });
        });
    },
    GetEmployees() {
      let uri;
      if (this.isRRHHOrCEO()) {
        uri = `/api/Employees/GetByCompany?companyID=${this.currentCompany}`;
      } else
        uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?employeeid=${this.currentUser.EmployeeId}`;
      // uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?DepartmentID=${this.deparmentId}&DirectionID=${this.currentUser.DireccionID}&employeeid=${this.currentUser.EmployeeId}`;
      this.$http
        .get(uri)
        .then((resp) => {
          if (this.isRRHHOrCEO()) {
            resp.data.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });
          } else {
            resp.data.user.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });

            resp.data.okEmployee.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });
          }
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              //message: "Cliente no encontrado, consultelo en otra empresa"
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        });
    },

    clear() {
      this.noDaysWithoutWeeknd = 0;
      this.model = {
        ApplicationDate: "",
        IdEmployee: this.currentUser.EmployeeId,
        Cedula: "",
        Department: "",
        Position: "",
        NoDays: 0,
        StartDate: "",
        FinishDate: "",
        Period: new Date().getFullYear(),
        Observations: "",
        SupervisorApproval: 0,
        RRHH_Approval: 0,
        SupervisorRejectionComment: null,
        RRHH_RejectionComment: null
      };
    },

    viewEvidence() {
      window.open(this.model.excution_evidence);
    }
  }
};
</script>
